import "@/user/common";
import initMoreClickButton from "@/shared/more_click";

document.addEventListener("DOMContentLoaded", () => {
  // 次の◯件を読み込み
  initMoreClickButton();
});
